import DesignTokens from '@tableau/design-tokens';
import { BroadcastBaseIcon } from '@tableau/icons/BroadcastBaseIcon';
import { BroadcastOffIcon } from '@tableau/icons/BroadcastOffIcon';
import { BroadcastOnIcon } from '@tableau/icons/BroadcastOnIcon';
import {
    ButtonType, ButtonWidget,
    InteractionState,
} from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { Loadable, LoadingStatus } from '~src/httpClient/utils/Loadable';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';
import { applyColor }from '~src/style/ColorService';

import { IBroadcastDetail } from '../models/BroadcastModels';
import { BroadcastViewDetailDialog } from './BroadcastViewDetailDialog';

const BROADCAST_BUTTON_ICON_TEST_ID = 'broadcast-icon';
export class BroadcastButton extends React.PureComponent<BroadcastButtonProps, BroadcastButtonStates> {

    constructor(props: BroadcastButtonProps) {
        super(props);
        this.state = { showingDialog: false };
    }

    public render() {
        return (
            <>
                <ButtonWidget
                    buttonType={ButtonType.IconOutline}
                    style={{ cursor: 'pointer' }}
                    testId={BROADCAST_BUTTON_ICON_TEST_ID}
                    getContent={this.buttonContent}
                    handleClick={this.toggleDialogVisibility}
                />
                {this.state.showingDialog && this.getBroadcastViewDetailDialog()}
            </>
        );
    }

    private buttonContent = (interactionState: InteractionState): JSX.Element => {
        const backgroundColor = { backgroundColor: interactionState.hover?applyColor(DesignTokens.color.component.background.neutral.default.active, '#ebebeb'):'transparent' };
        return (
            <span className={PageHeaderStyles.TextButton} style={backgroundColor}>
                {this.getIcon()}
            </span>
        );
    };

    private getIcon = (): JSX.Element => {
        const isBroadcast = !!this.props.broadcastStatus.content;
        const color = applyColor(DesignTokens.color.icon.default.default, '#666666');
        // display base icon when error occurs to broadcast that broadcast is not load, this should not happen
        if (this.props.broadcastStatus.loadingStatus === LoadingStatus.NOT_LOADED) {
            return <BroadcastBaseIcon size={20} color={color} style={PageHeaderStyles.iconOnlyButton} alt={Messages.broadcastIcon()} />;
        }
        // display current status of broadcast
        return isBroadcast
            ? <BroadcastOnIcon size={20} color={color} style={PageHeaderStyles.iconOnlyButton} alt={Messages.broadcastOn()} />
            : <BroadcastOffIcon size={20} color={color} style={PageHeaderStyles.iconOnlyButton} alt={Messages.broadcastOff()} />;
    };

    private toggleDialogVisibility = () => {
        this.setState((prev) => {
            return { showingDialog: !prev.showingDialog };
        });
    };

    private hideDialog = () => {
        this.setState({ showingDialog: false });
    };

    private getBroadcastViewDetailDialog = () => {
        return (<BroadcastViewDetailDialog
            broadcastStatus={this.props.broadcastStatus}
            broadcastDetail={this.props.broadcastDetail}
            onCreateBroadcast={this.props.onCreateBroadcast}
            onDeleteBroadcast={this.props.onDeleteBroadcast}
            onCloseRequest={this.hideDialog}
            viewName={this.props.viewName} />);
    };
}

export interface BroadcastButtonProps {
    readonly broadcastStatus: Loadable<boolean>;
    readonly broadcastDetail: Loadable<IBroadcastDetail>;
    readonly viewName: string;
    onCreateBroadcast: () => void;
    onDeleteBroadcast: () => void;
    getBroadcastDetail: () => void;
}

export interface BroadcastButtonStates {
    readonly showingDialog: boolean;
}
